import React, { useEffect, useState } from "react";
import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";

import { withAuthenticator } from "@aws-amplify/ui-react";
import { TopBar } from "components/topBar";
import { getCurrentUser, AuthUser } from "aws-amplify/auth";
import {
  SwaggerLayoutPlugin,
  //SwaggerLayoutPluginV4,
} from "components/swagger/plugins";
import { Button, IconButton } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { useStyles } from "./App.styles";
import { ChangeLog } from "./components/changelog/index";

const dev = process.env.NODE_ENV === "development";

const App = () => {
  const classes = useStyles();
  var scoreboardV3 = require("./scoreboardV3.json");
  var scoreboardV4 = require("./scoreboardV4.json");

  const [currentUser, setCurrentUser] = useState<AuthUser>();
  const [viewV3, setV3] = useState(false);
  const [viewChangeLog, setChangeLog] = useState(false);

  useEffect(() => {
    const getAuthenticatedUser = async () => {
      try {
        const user = await getCurrentUser();
        setCurrentUser(user);
      } catch (err) {
        console.info(err);
      }
    };
    getAuthenticatedUser();
  }, []);

  // Handle ESC key to close changelog
  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      if (event.key === "Escape" && viewChangeLog) {
        setChangeLog(false);
      }
    };

    if (viewChangeLog) {
      document.addEventListener("keydown", handleKeyPress);
    }

    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, [viewChangeLog]);

  return (
    <div>
      <TopBar heading="Cyber Risk" loggedIn={!!currentUser} />
      <Button className={classes.versionButton} onClick={() => setV3(!viewV3)}>
        API {!viewV3 ? "V3" : "v4"}
      </Button>
      {!viewV3 && (
        <Button
          className={classes.versionButton}
          onClick={() => setChangeLog(true)}
          style={{ marginTop: "40px" }}
        >
          Changelog
        </Button>
      )}
      {/* Modal backdrop */}
      <div
        className={`${classes.modalBackdrop} ${viewChangeLog ? "visible" : ""}`}
        onClick={() => setChangeLog(false)}
      />
      <div
        className={classes.changelog}
        style={
          viewChangeLog
            ? {
                width: "min(800px, 60vw)",
                padding: "60px 24px 24px 24px",
                minWidth: "600px",
                overflow: "auto",
              }
            : { width: 0, padding: 0, overflow: "hidden" }
        }
      >
        {viewChangeLog && (
          <IconButton
            className={classes.closeButton}
            onClick={() => setChangeLog(false)}
            title="Close changelog"
          >
            <Close />
          </IconButton>
        )}
        {viewChangeLog && <ChangeLog />}
      </div>
      {!viewV3 && (
        <div className={classes.content}>
          <SwaggerUI
            defaultModelsExpandDepth={-1}
            spec={scoreboardV4}
            docExpansion="none"
            //tryItOutEnabled={true}
          />
        </div>
      )}
      {viewV3 && (
        <div className={classes.content}>
          <SwaggerUI spec={scoreboardV3} plugins={[SwaggerLayoutPlugin]} />
        </div>
      )}
    </div>
  );
};

export default dev ? App : withAuthenticator(App, { hideSignUp: true });
